import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerLeadProfileService } from '../owner-lead-profile.service';
import { OwnerLeadProfile } from '../owner-lead-profile';
import { OwnerLeadProfileComponent } from '../owner-lead-profile/owner-lead-profile.component';
import { RealtorProfileService } from '@app/_components/realtor-profile/realtor-profile.service';
import {ImportExportComponent} from '@app/_components/_helpers/import-export/import-export.component';
import {Location} from "@angular/common";


@Component({
    selector: 'app-owner-lead-profile-list',
    templateUrl: './owner-lead-profile-list.component.html',
    styleUrls: ['./owner-lead-profile-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OwnerLeadProfileListComponent implements OnInit {
	leadStatuses: any;
	realtorProfilesList: any;
  sampleLink = 'https://s3.us-east-1.amazonaws.com/img.kbmblog.com/import_owner_profile_sample.xlsx';
	constructor(
		private ownerLeadProfileService: OwnerLeadProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private realtorProfileService: RealtorProfileService,
		private location1: Location,
		private dialog: MatDialog,
	) {
		this.leadStatuses = this.ownerLeadProfileService.leadStatuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
  @ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	ownerLeadProfiles: any;
	ownerLeadProfile: OwnerLeadProfile;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	columns: any[] = [
		{ field: 'firstName', header: 'First Name', width: 'auto',sorting: true },
		{ field: 'lastName', header: 'Last Name', width: 'auto',sorting: true },
		{ field: 'assignToSalesAgnt1', header: 'Sales Agent 1', width: 'auto',sorting: true },
		{ field: 'assignToSalesAgnt2', header: 'Sales Agent 2', width: 'auto',sorting: true },
		{ field: 'leadSource', header: 'Lead Source', width: 'auto',sorting: true },
		{ field: 'leadType', header: 'Lead Type', width: 'auto',sorting: true },
		{ field: 'leadStatus', header: 'Status', width: 'auto',sorting: false },
		{ field: 'title', header: 'Title', width: 'auto',sorting: true },
		{ field: 'createDate', header: 'Create Date', width: 'auto',sorting: true },
		{ field: 'lastUpdate', header: 'Last Update Date', width: 'auto',sorting: true },
		{ field: 'realtorProfile.lastName', header: 'Realtor', width: 'auto',sorting: true },
	];

	ngOnInit(): void {
		this.fetchRealtorProfiles();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ownerLeadProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerLeadProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerLeadProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerLeadProfiles = res.data.ownerLeadProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerLeadProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	getFilteredTags(tags) {
		//if filter text input is empty then load all records
		if(tags == '0') {
			delete this.lazyLoadEvent.filters.ownerLeadProfileId;
			this.loadLazy(this.lazyLoadEvent);
		} else {
			//If records found then show filtered records
			if(tags.length > 0) {
				//if filter text input is not empty then load filtered records only
				var filteredOwnerLeadIds = [];
				tags.forEach(tag => {
					filteredOwnerLeadIds.push(tag.tagSourceId);
				});
				let activityProviderIdFilter = { 'ownerLeadProfileId': { 'value': filteredOwnerLeadIds, 'matchMode': 'in' } };
				Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
				this.loadLazy(this.lazyLoadEvent);
			} else {
				//Display empty table as no record found with filtered input
				this.ownerLeadProfiles = [];
			}
		}
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ownerLeadProfile: OwnerLeadProfile) {
		try {
			this.formLoading = true;
			this.ownerLeadProfileService.update(ownerLeadProfile)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ownerLeadProfiles.map((ownerLeadProfile, i) => {
							if (ownerLeadProfile.ownerLeadProfileId === res.data.ownerLeadProfile.ownerLeadProfileId) {
								this.ownerLeadProfiles[i] = res.data.ownerLeadProfile;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ownerLeadProfile: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ownerLeadProfile));

			this.formLoading = true;
			this.ownerLeadProfileService.delete(ownerLeadProfile.ownerLeadProfileId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ownerLeadProfiles.splice(this.ownerLeadProfiles.indexOf(ownerLeadProfile), 1);
						this.recordTotal = this.ownerLeadProfiles.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OwnerLeadProfile ' + ownerLeadProfile.ownerLeadProfileId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OwnerLeadProfile ' + ownerLeadProfile.ownerLeadProfileId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "1600px";
		dialogConfig.width = "80vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Owner Lead Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerLeadProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.addOwnerLeadProfileCB(data);

				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ownerLeadProfile: OwnerLeadProfile) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerLeadProfile: ownerLeadProfile,
			title: 'Edit Owner Lead Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerLeadProfileComponent, dialogConfig);
		this.location1.go('/owner-lead-profile-view/' + ownerLeadProfile?.ownerLeadProfileId);
		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.location1.go('/owner-lead-profile-list');
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.updateOwnerLeadProfileCB(data);
				if (data === "close") {
					// close the dialogBox
					dialogRef.close();
				}

				this.loadLazy(this.lazyLoadEvent);
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOwnerLeadProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOwnerLeadProfileCB(ownerLeadProfile: OwnerLeadProfile) {
		console.log('Adding OwnerLeadProfile: ' + JSON.stringify(ownerLeadProfile));
		// if we don't have a ownerLeadProfiles array yet...
		if (!this.ownerLeadProfiles) {
			this.ownerLeadProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ownerLeadProfiles.unshift(ownerLeadProfile);

		// no idea what this is but it is required to update the array
		this.ownerLeadProfiles = [...this.ownerLeadProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerLeadProfile ' + ownerLeadProfile.ownerLeadProfileId + ' Added', life: 3000 });
	}

	updateOwnerLeadProfileCB(ownerLeadProfile: OwnerLeadProfile) {
		console.log('Updating OwnerLeadProfile: ' + JSON.stringify(ownerLeadProfile));
		let itemIndex = this.ownerLeadProfiles.findIndex((item: any) => item.ownerLeadProfileId === ownerLeadProfile.ownerLeadProfileId);
		this.ownerLeadProfiles[itemIndex] = ownerLeadProfile;

		// no idea what this is but it is required to update the array
		this.ownerLeadProfiles = [...this.ownerLeadProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerLeadProfile ' + ownerLeadProfile.ownerLeadProfileId + ' Updated', life: 3000 });
	}

	deleteOwnerLeadProfileCB(ownerLeadProfile: OwnerLeadProfile) {
		console.log('Removing OwnerLeadProfile: ' + ownerLeadProfile);
		this.ownerLeadProfiles.splice(this.ownerLeadProfiles.indexOf(ownerLeadProfile), 1);
		this.recordTotal = this.ownerLeadProfiles.length;

		// no idea what this is but it is required to update the array
		this.ownerLeadProfiles = [...this.ownerLeadProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerLeadProfile ' + ownerLeadProfile.ownerLeadProfileId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ownerLeadProfiles ? this.first === (this.ownerLeadProfiles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ownerLeadProfiles ? this.first === 0 : true; }


	getStatusName(ownerLeadProfile: any) {
		if (ownerLeadProfile?.leadStatus) {
			const status = this.leadStatuses.find((e: any) => e.value == ownerLeadProfile.leadStatus);
			return status?.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	// get all realtor profiles
	fetchRealtorProfiles(){
		try {
			this.realtorProfileService.findAll()
				.subscribe(
					res => {
						 console.log('findAllRealtorProfiles: ' + JSON.stringify(res));
						this.realtorProfilesList = res.data.realtorProfiles;
						return this.realtorProfilesList;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	getRealtorLastName(ownerLeadProfile: any) {
		if (ownerLeadProfile?.realtorProfileId) {
			const realtorProfile = this.realtorProfilesList.find((e: any) => e.realtorProfileId == ownerLeadProfile?.realtorProfileId);
			return realtorProfile.lastName;
		}
		else {
			return '';
		}
	}
  dataAndTagSelected($event: any) {
    let data = $event.jsonArrayRaw;
    let tagsSelected = $event.tagJoinAPIList;
    let ownerProfiles = [];
    data.forEach(json => {
      try {
        const profile = new OwnerLeadProfile();
        profile.emailAddress = json.emailAddress;
        profile.firstName = json.firstName;
        profile.lastName = json.lastName;
        profile.subjAdrStreet = json.subjAdrStreet;
        profile.mobilePhone = json.mobilePhone;
        profile.phone2 = json.phone2;
        profile.leadStatus = json.leadStatus;
        profile.mailAdrStreet = json.mailAdrStreet;
        profile.mailAdrCity = json.mailAdrCity;
        profile.mailAdrState = json.mailAdrState;
        profile.mailAdrCountry = json.mailAdrCountry;
        profile.mailAdrPostalCode = json.mailAdrPostalCode;
        profile.unitNumber = json.unitNumber
        ;
        ownerProfiles.push(profile);
      } catch (e) {
      }
    });
    let postingData = {
      tagJoinAPIList: tagsSelected,
      ownerLeadProfileAPIList: ownerProfiles
    };
    this.ownerLeadProfileService.importOwnerLeadProfile(postingData)
      .subscribe(
        (res: any) => {
          console.log('property-add SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({severity: 'success', summary: 'Success', detail: 'Owner Lead Profiles imported successful'});
          this.reloadPage();
        },
        (err: any) => {
          console.log('import Owner Lead-add FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        });
  }

  exportSelected($event: any) {
    this.loadLazyForExport($event);
  }

  loadLazyForExport(exporttype) {
    let event = this.lazyLoadEvent;
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );
      event.rows = 1000;
      /*
      *
      * Default Sort
      */
      // https://stackoverflow.com/questions/679915/how-do-i-ownerLeadProfile-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: 'createDate', order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      this.ownerLeadProfileService.findByFilter(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters).pipe(first()).subscribe(

        (res: any) => {
          this.datasource = res.data.reviews;
          this.recordTotal = res.page.recordTotal;
          this.ownerLeadProfiles = res.data.ownerLeadProfiles;
          this.importExportComponent.exporData(exporttype, res.data.ownerLeadProfiles, 'Owner Lead Profiles');
        },
        (err: any) => {
          console.log('reviews list error!: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => { this.loading = false; }
      );

      if (this.datasource) {
        this.ownerLeadProfiles = this.datasource.slice(event.first, (event.first + event.rows));
      }
    } catch (error) {
      console.log('loadLazy(' + event + ')' + error);
    }
  }
}
